<p-table [value]="logs" #table [globalFilterFields]="['executor', 'source', 'destination']">
    <ng-template pTemplate="header">

    </ng-template>
    <ng-template pTemplate="caption">
        <div class="col-12 pt-3 pb-0 px-0">
            <div class="flex flex-1 flex-row"  id="searchBarContainer">
                <span class="p-input-icon-left w-full relative">
                    <i class="pl-2 far fa-magnifying-glass absolute top-0 bottom-0 m-auto" style="height: fit-content"></i>
                    <input type="text" class="w-full" pInputText id="searchBar" (input)="table.filterGlobal($event.target['value'], 'contains')"/>
                </span>
            </div>
<!--            <div class="fluid">-->
<!--                 <span class="p-input-icon-left">-->
<!--                      <i class="far fa-magnifying-glass"></i>-->
<!--                      <input pInputText type="text" (input)="table.filterGlobal($event.target['value'], 'contains')"-->
<!--                             placeholder="Suche" i18n-placeholder="@@filestore-operation-log.search" style="width:100%"/>-->
<!--                  </span>-->
<!--            </div>-->
        </div>
    </ng-template>
    <ng-template pTemplate="body" let-log>
        <tr>
            <td>
                <div class="underline mb-2">{{log.created | date: 'medium'}}</div>
                <div>
                    <span>{{log.executor}}</span>&nbsp;
                    <ng-container *ngIf="log.operationType === 'CREATE_FILE'">
                        <span i18n="@@filestore-operation-log.create-file">has created the file <b>{{log.source}}</b></span>
                    </ng-container>
                    <ng-container *ngIf="log.operationType === 'CREATE_DIRECTORY'">
                        <span i18n="@@filestore-operation-log.create-directory">has created the directory <b>{{log.source}}</b></span>
                    </ng-container>
                    <ng-container *ngIf="log.operationType === 'DELETE'">
                        <span i18n="@@filestore-operation-log.delete">has deleted <b>{{log.source}}</b></span>
                    </ng-container>
                    <ng-container *ngIf="log.operationType === 'RENAME'">
                        <span i18n="@@filestore-operation-log.renamed">has renamed <b>{{log.source}}</b> to <b>{{log.destination}}</b></span>
                    </ng-container>
                    <ng-container *ngIf="log.operationType === 'MOVE'">
                        <span i18n="@@filestore-operation-log.move">has moved <b>{{log.source}}</b> to <b>{{log.destination}}</b></span>
                    </ng-container>
                    <ng-container *ngIf="log.operationType === 'CHANGE_DISPLAY_NAME'">
                        <span i18n="@@filestore-operation-log.change-display-name">has changed display name <b>{{log.source}}</b> to <b>{{log.destination}}</b></span>
                    </ng-container>
                    <ng-container *ngIf="log.operationType === 'CHANGE_ALT_TEXT'">
                        <span i18n="@@filestore-operation-log.change-alt-text">has changed the alternative text <b>{{log.source}}</b> to <b>{{log.destination}}</b></span>
                    </ng-container>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
